"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _balanceBatchSend = require("@/api/balanceBatchSend");
var _download = require("@/utils/download");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      taskId: '',
      dialogVisible: false,
      status: '',
      giveStatus: '',
      phone: '',
      page: 1,
      size: 10,
      total: 1,
      tableList: []
    };
  },
  methods: {
    open: function open(data) {
      this.dialogVisible = true;
      this.taskId = data.id;
      this.find();
    },
    search: function search() {
      this.page = 1;
      this.find();
    },
    rest: function rest() {
      this.status = '';
      this.giveStatus = '';
      this.phone = '';
      this.find();
    },
    downLoad: function downLoad() {
      (0, _download.selfDownload)("/portal/system/balance/downloadData?taskId=".concat(this.taskId, "&phone=").concat(this.phone, "&status=").concat(this.status, "&giveStatus=").concat(this.giveStatus));
    },
    send: function send() {
      var _this = this;
      this.$confirm('确认发放余额?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _balanceBatchSend.reissue)({
          taskId: _this.taskId
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            setTimeout(function () {
              _this.rest();
              _this.page = 1;
              _this.find();
            });
          }
        });
      });
    },
    find: function find() {
      var _this2 = this;
      (0, _balanceBatchSend.detail)({
        taskId: this.taskId,
        phone: this.phone,
        status: this.status,
        giveStatus: this.giveStatus,
        page: this.page,
        size: this.size
      }).then(function (res) {
        _this2.total = res.data.total;
        _this2.tableList = res.data.data;
      });
    },
    onClose: function onClose() {
      this.dialogVisible = false;
      this.tableList = [];
      this.status = '';
      this.giveStatus = '';
      this.phone = '';
      this.page = 1;
      this.total = 0;
      this.size = 10;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.find();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.find();
    }
  }
};